
export const Bio = {
  name: "Balachandren Thinusan",
  roles: [
    "Full Stack Developer",
    "Android Developer",
    "Intern software developer"
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/Thinusan",
  resume:
    "https://drive.google.com/file/d/18ZB754lXlqeC-iagM5FfKamhKJ5sjG-d/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/thinusan-balachandren-13a13926b/",
  insta: "https://www.instagram.com/Thinusan Balachandren/",
  facebook: "https://www.facebook.com/Thinusan Balachandren/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      
      
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Php",
        image:
          "https://www.php.net/images/logos/new-php-logo.png",
      },
      {
        name: "Flutter",
        image:
          "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Kotlin",
        image:
          "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
      },
      
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      
      {
        name: "google colab",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/d/d0/Google_Colaboratory_SVG_Logo.svg",
      },
      
    ],
  },
];



export const education = [
  {
    id: 0,
    img: "https://www.uwu.ac.lk/wp-content/uploads/logo_uwu.jpg",
    school: "Uva Wellasa University of Sri Lanka",
    date: " 2020 - 2024",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Technology at Uva Wellasa University of Sri Lanka. I have completed 7 semesters yet with around 3.2 CGPA.",
    
  },
  
];

export const projects = [
  {
    id: 1,
    title: "Hangman",
    date: "2024",
    description:
      "Hangman is a game which is inspired by english dictionary.Here i have created a game like a hangman concept and give an clue to find an english word and given 6 wrong guess and the player should find the correct word with the help of the clue",
    image:
      "https://github.com/Thinusan/hangman/blob/main/Screenshot%20(6).png?raw=true",
    tags: [
      "HTML",
      "CSS",
      "JavaScript",
      
    ],
    category: "web app",
    github: "https://github.com/Thinusan/hangman/tree/main",
    webapp: "https://github.com/Thinusan/hangman/tree/main",
  },
  {
    id: 2,
    title: "Piano",
    date: "2024",
    description:
      "I have made an attractive online paino keyboard which is 100 percentage playable for fun and relaxation.",
    image:
      "https://github.com/Thinusan/piano/blob/main/Screenshot%20(7).png?raw=true",
    tags: ["HTML", "CSS", "JavaScript"],
    category: "web app",
    github: "https://github.com/Thinusan/piano",
    webapp: "https://github.com/Thinusan/piano",
    
  },
  {
    id: 3,
    title: "Online food ordering system",
    date: "2022",
    description:
      "I have created an online food ordering system for an rasturant ",
    image:
      "",
    tags: [
      "php",
      "MySQL",
    ],
    category: "web app",
    github: "https://github.com/Thinusan/ordering",
    webapp: "https://github.com/Thinusan/ordering",
  },
  {
    id: 2,
    title: "Brain Tumor Detection",
    date: "2024 present",
    description:
      "For my final year research we 3 people are doing a research on brain tumour detection using CNN,SVM and a new model.We haven't finished it,we are currently doing that project.I have uploaded an image of and model image of the preview of how our research shall end",
    image:
      "https://github.com/rishavchanda/Brain-Tumor-Detection/raw/main/Readme_resource/Image2.png",
    tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    category: "machine learning",
    
    
  },
  {
    id: 4,
    title: "NCH",
    date: "2021",
    description:
    "I have created an effective website for a hospital for my 2nd year individual project",
    image:
      "https://github.com/Thinusan/NCH-Website/blob/main/Screenshot%20(11).png?raw=true",
    tags: ["HTML", "CSS", "JavaScript","Bootstrap", "MySQL"],
    category: "Web app",
    github: "https://github.com/Thinusan/NCH-Website",
    webapp: "https://github.com/Thinusan/NCH-Website",
  },
  {
    id: 5,
    title: "ACX",
    date: "2021",
    description:
      "I have created an efficient website for an mobile phone shop for my 1st year individual project",
    image:
      "https://github.com/Thinusan/ACX/blob/main/js/Screenshot%20(8).png?raw=true",
    tags: ["HTML", "CSS", "JavaScript","Bootstrap","php", "MySQL"],
    category: "Web app",
    github: "https://github.com/Thinusan/ACX",
    webapp: "https://github.com/Thinusan/ACX",
  },
  {
    id: 4,
    title: "Tik Tac toe",
    date: "2024",
    description:
      "I have created an fun and stressfree TikTacToe game in the period of studying reactjs",
    image:
      "https://github.com/Thinusan/tik/blob/master/Screenshot%20(12).png?raw=true",
    tags: ["React Js"],
    category: "web app",
    github: "https://github.com/Thinusan/tik",
    webapp: "https://github.com/Thinusan/tik",
  },
  {
    id: 5,
    title: "Agricultural consultancy",
    date: "2023",
    description:
     "I have created an mobile application for my 3rd year project with 3 of my friends as a group project.We have created both page for admin and the customers successfully and got a good positive feedback from the client,but he hasn't deploy the app as he is facing some difficulty in his shop",
    image:
      "https://github.com/Sharangan13/project_02_final/blob/master/WhatsApp%20Image%202024-01-24%20at%2023.51.05.jpeg?raw=true",
    tags: ["Flutter", "Dart", "Firebase"],
    category: "android app",
    github: "https://github.com/Sharangan13/project_02_final",
    webapp: "https://github.com/Sharangan13/project_02_final",
  },
  
];

export const TimeLineData = [
  { year: 2017, text: "Sat for Advanced Level Examination " },
  { year: 2018, text: "Sat for Advanced Level Examination for the 2nd time" },
  { year: 2020, text: "Enrolled for Uva Wellasa University of Sri Lanka" },
 
];
